import { render, staticRenderFns } from "./sale-report-print.vue?vue&type=template&id=61d8dc6c&scoped=true"
import script from "./sale-report-print.vue?vue&type=script&lang=js"
export * from "./sale-report-print.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d8dc6c",
  null
  
)

export default component.exports